export const REQUEST_ARTICLE_LIST = 'REQUEST_ARTICLE_LIST';
export const RECEIVE_ARTICLE_LIST = 'RECEIVE_ARTICLE_LIST';
export const RECEIVE_ARTICLE_LIST_ERROR = 'RECEIVE_ARTICLE_LIST_ERROR';

export const REQUEST_TOPIC_TREE = 'REQUEST_HOME_TOPIC_TREE';
export const RESPONSE_TOPIC_TREE = 'RESPONSE_HOME_TOPIC_TREE';
export const ERROR_TOPIC_TREE = 'ERROR_HOME_TOPIC_TREE';

export const REQUEST_POPULAR_LIST = 'REQUEST_POPULAR_LIST';
export const RECEIVE_POPULAR_LIST = 'RECEIVE_POPULAR_LIST';
export const RECEIVE_POPULAR_ERROR = 'RECEIVE_POPULAR_ERROR';

export const REQUEST_COMMUNITY_RESULTS = 'REQUEST_COMMUNITY_RESULTS';
export const RECEIVE_COMMUNITY_RESULTS = 'RECEIVE_COMMUNITY_RESULTS';
export const RECEIVE_COMMUNITY_ERROR = 'RECEIVE_COMMUNITY_ERROR';

export const UPDATE_BREADCRUMB = 'UPDATE_BREADCRUMB';

export const TOGGLE_RELATED = 'TOGGLE_RELATED';

export const RELATED_TOGGLE_RESET = 'RELATED_TOGGLE_RESET';
export const RESET_BREADCRUMB = 'RESET_BREADCRUMB';

export const REQUEST_OPEN_CASE = 'REQUEST_OPEN_CASE';
export const RECEIVE_OPEN_CASE = 'RECEIVE_OPEN_CASE';
export const RECEIVE_OPEN_CASE_ERROR = 'RECEIVE_OPEN_CASE_ERROR';

// Machine Translation Article Request
export const REQUEST_MACHINE_ARTICLE = 'REQUEST_MACHINE_ARTICLE';
export const RECEIVE_MACHINE_ARTICLE_RESPONSE = 'RECEIVE_MACHINE_ARTICLE_RESPONSE';
export const RECEIVE_MACHINE_ARTICLE_ERROR = 'RECEIVE_MACHINE_ARTICLE_ERROR';
